import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-230316d1")

_pushScopeId("data-v-230316d1")
const _hoisted_1 = { class: "enterprise" }
const _hoisted_2 = { class: "enterprise-head" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "enterprise-head__title" }, [
  /*#__PURE__*/_createVNode("span", { class: "title" }, "企业详情")
], -1)
const _hoisted_4 = { class: "enterprise-head__action" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 导出备案清单 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "el-dropdown-link" }, [
  /*#__PURE__*/_createVNode("span", null, "选择操作"),
  /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("续签")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("调整试用时间")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("增减车辆数")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_11 = { class: "detail-type" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("查看logo")
const _hoisted_13 = { class: "detail-type" }
const _hoisted_14 = { class: "detail-type" }
const _hoisted_15 = { class: "detail-type" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "detail-type" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "detail-type" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { class: "detail-type" }
const _hoisted_27 = { class: "detail-type" }
const _hoisted_28 = { class: "detail-type" }
const _hoisted_29 = { class: "detail-type" }
const _hoisted_30 = { class: "detail-type" }
const _hoisted_31 = { class: "detail-type" }
const _hoisted_32 = { class: "detail-type" }
const _hoisted_33 = { class: "detail-type" }
const _hoisted_34 = { class: "detail-type" }
const _hoisted_35 = { class: "detail-type" }
const _hoisted_36 = { class: "detail-type" }
const _hoisted_37 = { class: "detail-type" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "detail-type" }
const _hoisted_41 = { class: "detail-type" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "detail-type" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { class: "detail-type" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { class: "detail-type" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { key: 2 }
const _hoisted_57 = { class: "detail-type" }
const _hoisted_58 = { class: "detail-type" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { key: 2 }
const _hoisted_62 = { class: "detail-type" }
const _hoisted_63 = { class: "detail-type" }
const _hoisted_64 = { class: "detail-type" }
const _hoisted_65 = { class: "detail-type" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "detail-type" }
const _hoisted_69 = { class: "detail-type" }
const _hoisted_70 = { class: "detail-type" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode("基本数据")
const _hoisted_72 = /*#__PURE__*/_createTextVNode("缴费记录")
const _hoisted_73 = /*#__PURE__*/_createTextVNode("扣费记录")
const _hoisted_74 = /*#__PURE__*/_createTextVNode("服务套餐记录")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("关联子公司")
const _hoisted_76 = /*#__PURE__*/_createTextVNode("关联违章API")
const _hoisted_77 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_c_img_view = _resolveComponent("c-img-view")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_radio_button = _resolveComponent("el-radio-button")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_renewal = _resolveComponent("renewal")
  const _component_TrialTime = _resolveComponent("TrialTime")
  const _component_carNum = _resolveComponent("carNum")
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")
  const _component_export_contract_dialog = _resolveComponent("export-contract-dialog")
  const _directive_hasAuth = _resolveDirective("hasAuth")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_el_button, {
          onClick: _ctx.handleExport,
          style: {"margin-right":"16px"}
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_directive_hasAuth, 'enterprise-exportViolationContractCar']
        ]),
        _createVNode(_component_el_dropdown, null, {
          dropdown: _withId(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withId(() => [
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.handleRenewal }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onToggle('isTrialTime')))
                }, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onToggle('isCarNum')))
                }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: _ctx.back }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.formData,
      rules: _ctx.rules,
      "label-width": "80px",
      "label-position": "top",
      class: "enterprise-form"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "企业编号",
                  prop: "enterpriseCode"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.formData.enterpriseCode || '暂无') + " ", 1),
                      (_ctx.formData.logo)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            link: "",
                            type: "text",
                            onClick: _cache[3] || (_cache[3] = 
                  () => {
                    _ctx.getFileUrlHandler(_ctx.formData.logo)
                  }
                )
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "企业名称",
                  prop: "name"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_13, _toDisplayString(_ctx.formData.name || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "组织机构代码",
                  prop: "orgCode"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.formData.orgCode || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "私有合作银行渠道",
                  prop: "orgCode"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_15, [
                      (_ctx.formData.bankRelated.length !== 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.combination(_ctx.formData.bankRelated)), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_17, "空"))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "企业类型",
                  prop: "systemPattern"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_18, [
                      (_ctx.formData.systemPattern === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_19, " EP模式 "))
                        : (_openBlock(), _createBlock("span", _hoisted_20, "集采模式"))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "系统类型",
                  prop: "systemType"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_21, [
                      (_ctx.formData.systemType === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_22, " 蓝鲸车管家 "))
                        : _createCommentVNode("", true),
                      (_ctx.formData.systemType === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_23, " 智享数字车管 "))
                        : _createCommentVNode("", true),
                      (_ctx.formData.systemType === 3)
                        ? (_openBlock(), _createBlock("span", _hoisted_24, " 交通卫星 "))
                        : _createCommentVNode("", true),
                      (_ctx.formData.systemType === 4)
                        ? (_openBlock(), _createBlock("span", _hoisted_25, " 自定类型：" + _toDisplayString(_ctx.formData.techProvider || '暂无'), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "经济类型" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_26, _toDisplayString(_ctx.economicsTypeMap[_ctx.formData.economicsType + ''] || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "经营状况" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_27, _toDisplayString(_ctx.economicsStatusMap[_ctx.formData.economicsStatus + ''] || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证字",
                  prop: "manageCard"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.formData.manageCard || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证号",
                  prop: "manageCardNum"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_29, _toDisplayString(_ctx.formData.manageCardNum || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证有效期起",
                  prop: "manageTimeStar"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_30, _toDisplayString(_ctx.formData.manageTimeStar || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证有效期止",
                  prop: "manageTimeEnd"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.formData.manageTimeEnd || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证初次发证日期",
                  prop: "manageTimeFirst"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_32, _toDisplayString(_ctx.formData.manageTimeFirst || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证发证机关",
                  prop: "cardOrg"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_33, _toDisplayString(_ctx.formData.cardOrg || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "注册地址",
                  prop: "signAddress"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_34, _toDisplayString(_ctx.formData.signAddress || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "企业简称",
                  prop: "abbrName"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.formData.abbrName || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "系统名称",
                  prop: "systemName"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.formData.systemName || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "独立访问地址",
                  prop: "domainHeader"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_37, [
                      (_ctx.formData.domainHeader)
                        ? (_openBlock(), _createBlock("span", _hoisted_38, "https://" + _toDisplayString(_ctx.formData.domainHeader) + ".ccclubs.com", 1))
                        : (_openBlock(), _createBlock("span", _hoisted_39, "暂无"))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营范围",
                  prop: "manageScope"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_40, _toDisplayString(_ctx.formData.manageScope || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "短信收费",
                  prop: "chargeSms"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_41, [
                      (_ctx.formData.chargeSms === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_42, "是"))
                        : (_ctx.formData.chargeSms === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_43, "否"))
                          : (_openBlock(), _createBlock("span", _hoisted_44, "暂无"))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "违章同步",
                  prop: "violationSync"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_45, [
                      (_ctx.formData.violationSync === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_46, "自动"))
                        : (_ctx.formData.violationSync === 2)
                          ? (_openBlock(), _createBlock("span", _hoisted_47, "非自动"))
                          : (_openBlock(), _createBlock("span", _hoisted_48, "暂无"))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "违章备案",
                  prop: "violationContractAdd"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_49, [
                      (_ctx.formData.violationContractAdd === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_50, "不支持"))
                        : (_ctx.formData.violationContractAdd === 2)
                          ? (_openBlock(), _createBlock("span", _hoisted_51, " 支持" + _toDisplayString(_ctx.formData.violationContractAddCount ? '（数量：' + _ctx.formData.violationContractAddCount + '）' : '（不限）'), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_52, "暂无"))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "违章转移",
                  prop: "violationContractTransfer"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_53, [
                      (_ctx.formData.violationContractTransfer === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_54, "不支持"))
                        : (_ctx.formData.violationContractTransfer === 2)
                          ? (_openBlock(), _createBlock("span", _hoisted_55, " 支持" + _toDisplayString(_ctx.formData.violationContractTransferCount ? '（数量：' + _ctx.formData.violationContractTransferCount + '）' : '（不限）'), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_56, "暂无"))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "锐明userSecret",
                  prop: "aebUserSecret"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_57, _toDisplayString(_ctx.formData.aebUserSecret || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "电子合同集采方",
                  prop: "electronicType"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_58, [
                      (_ctx.formData.electronicType === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_59, "车厘子原APPID"))
                        : (_ctx.formData.electronicType === 2)
                          ? (_openBlock(), _createBlock("span", _hoisted_60, "车网新APPID"))
                          : (_openBlock(), _createBlock("span", _hoisted_61, "暂无"))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "注册资本（万元）",
                  prop: "signMoney"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_62, _toDisplayString(_ctx.formData.signMoney || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "联系人",
                  prop: "contacts"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_63, _toDisplayString(_ctx.formData.contacts || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "联系电话",
                  prop: "contactsPhone"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_64, _toDisplayString(_ctx.formData.contactsPhone || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "含有子公司",
                  prop: "jtqy"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_65, [
                      (_ctx.formData.collectivized === 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_66, "否"))
                        : (_ctx.formData.collectivized === 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_67, "是"))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "法定代表",
                  prop: "legalPerson"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_68, _toDisplayString(_ctx.formData.legalPerson || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              prop: "contactsAddress"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "联系地址" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_69, _toDisplayString(_ctx.formData.contactsArea) + _toDisplayString(_ctx.formData.contactsAddress || '暂无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "营业执照" }, {
                  default: _withId(() => [
                    _createVNode(_component_c_img_view, { images: _ctx.businessLicenseJpgList }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessLicenseJpgList, (item, index) => {
                          return (_openBlock(), _createBlock("img", {
                            src: item,
                            key: index,
                            width: "200",
                            style: {"margin-right":"10px"}
                          }, null, 8, ["src"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["images"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "经营许可证" }, {
                  default: _withId(() => [
                    _createVNode(_component_c_img_view, { images: _ctx.managePermissionJpgList }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.managePermissionJpgList, (item, index) => {
                          return (_openBlock(), _createBlock("img", {
                            src: item,
                            key: index,
                            width: "200",
                            style: {"margin-right":"10px"}
                          }, null, 8, ["src"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["images"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "状态",
                  prop: "enterpriseStatus"
                }, {
                  default: _withId(() => [
                    _createVNode("span", _hoisted_70, _toDisplayString(_ctx.formData.enterpriseStatus === 1 ? '正常' : '禁用'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_radio_group, {
      modelValue: _ctx.tabsName,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.tabsName = $event)),
      style: {"margin-bottom":"30px"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_radio_button, { label: "BasicDataComp" }, {
          default: _withId(() => [
            _hoisted_71
          ]),
          _: 1
        }),
        _createVNode(_component_el_radio_button, { label: "PaymentComp" }, {
          default: _withId(() => [
            _hoisted_72
          ]),
          _: 1
        }),
        _createVNode(_component_el_radio_button, { label: "DeductionComp" }, {
          default: _withId(() => [
            _hoisted_73
          ]),
          _: 1
        }),
        _createVNode(_component_el_radio_button, { label: "CompanyComp" }, {
          default: _withId(() => [
            _hoisted_74
          ]),
          _: 1
        }),
        _createVNode(_component_el_radio_button, { label: "AffiliatedSubsidiaries" }, {
          default: _withId(() => [
            _hoisted_75
          ]),
          _: 1
        }),
        _createVNode(_component_el_radio_button, { label: "API" }, {
          default: _withId(() => [
            _hoisted_76
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tabsName), { "row-data": _ctx.formData }, null, 8, ["row-data"])),
    _hoisted_77,
    _hoisted_78,
    (_ctx.isRenewal)
      ? (_openBlock(), _createBlock(_component_renewal, {
          key: 0,
          "row-data": _ctx.rowData,
          visible: _ctx.isRenewal,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isRenewal = $event))
        }, null, 8, ["row-data", "visible"]))
      : _createCommentVNode("", true),
    (_ctx.isTrialTime)
      ? (_openBlock(), _createBlock(_component_TrialTime, {
          key: 1,
          "row-data": _ctx.rowData,
          visible: _ctx.isTrialTime,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isTrialTime = $event))
        }, null, 8, ["row-data", "visible"]))
      : _createCommentVNode("", true),
    (_ctx.isCarNum)
      ? (_openBlock(), _createBlock(_component_carNum, {
          key: 2,
          "row-data": _ctx.rowData,
          visible: _ctx.isCarNum,
          "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isCarNum = $event))
        }, null, 8, ["row-data", "visible"]))
      : _createCommentVNode("", true),
    (_ctx.isImgViewer)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 3,
          "url-list": _ctx.currentImages,
          onClose: 
        () => {
          _ctx.isImgViewer = false
        }
      
        }, null, 8, ["url-list", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isExportDialogVisible)
      ? (_openBlock(), _createBlock(_component_export_contract_dialog, {
          key: 4,
          visible: _ctx.isExportDialogVisible,
          "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isExportDialogVisible = $event)),
          companyUuid: _ctx.formData.uuid
        }, null, 8, ["visible", "companyUuid"]))
      : _createCommentVNode("", true)
  ]))
})